// import RecentPosts from 'components/recent-posts';

// Register react components that can be used in markdown.
// The property key is the custom tag used in markdown.
// ex. <example-component></example-component> equates to 'example-component': ExampleComponent
export default {
  // recentPosts: RecentPosts,
};
